import {instance} from './index';

export const argusAPI = {
  addArgusStatistic (data) {
    return instance.post('blog/addArgusStatistics', data)
  },
  getArgusStatistic () {
    return instance.get('blog/getArgusStatistics')
  },
}